import React, { Component } from 'react';
import { Field } from 'redux-form';
import Icon from '../icons/Icon';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment-timezone';
import { everyHalfHour, businessHours } from '../utils/times';
import 'react-dates/lib/css/_datepicker.css';

const renderDatePicker = ({ input, focused, onFocusChange, isMobile, meta: { touched, error }, isOutsideRange }) => {
  const date = input.value ? moment(input.value) : null;

  return (
    <div>
      <div className="date-time-picker">
        <SingleDatePicker
          id="date_input"
          date={date}
          onDateChange={input.onChange}
          focused={focused}
          onFocusChange={onFocusChange}
          numberOfMonths={isMobile ? 1 : 2}
          isOutsideRange={isOutsideRange}
        />
      </div>
      {touched && error && <span className="input-validation">{error}</span>}
    </div>
  );
};

const renderTimePicker = ({ type, input, meta: { touched, error } }) => {
  const times = type === 'movement-specialist' ? everyHalfHour() : businessHours();
  return (
    <div className={input.value.length > 0 ? 'date-time-picker__select' : 'date-time-picker__select time__placeholder'}>
      <select onChange={input.onChange} value={input.value || ''}>
        {times.map((time, i) => (
          <option key={i} value={time}>
            {time}
          </option>
        ))}
      </select>
      {touched && error && <span className="input-validation">{error}</span>}
    </div>
  );
};

class ReduxFormDateTimeArrayInput extends Component {
  state = {
    focusedDatePicker: 0,
  };

  setFocusedDatePicker(index, value) {
    this.setState({ focusedDatePicker: value.focused ? index + 1 : 0 });
  }

  isOutsideRange = day => {
    if (this.props.allowDays) {
      const latestDay = moment().add(this.props.allowDays, 'days');

      return day.isBefore(moment().add(1, 'day')) || day.isAfter(latestDay);
    }

    return false;
  };

  render() {
    const { fields, meta: { touched, error, submitFailed }, minSize, maxSize, isMobile, type } = this.props;
    const { focusedDatePicker } = this.state;

    return (
      <div>
        <ul>
          <li>{(touched || submitFailed) && error && <span>{error}</span>}</li>
          {fields.map((option, index) => (
            <li key={index}>
              <div className="date-time">
                <div>
                  <span>Date</span>
                  <Field
                    name={`${option}.date`}
                    component={renderDatePicker}
                    focused={focusedDatePicker === index + 1}
                    onFocusChange={this.setFocusedDatePicker.bind(this, index)}
                    isMobile={isMobile}
                    isOutsideRange={this.isOutsideRange}
                  />
                </div>
                <div>
                  <span>
                    Time ({moment()
                      .tz(this.props.timezone)
                      .format('z')})
                  </span>
                  <Field name={`${option}.time`} component={renderTimePicker} type={type} />
                </div>
              </div>
              {fields.length > minSize || 0 ? (
                <span className="date-time__delete" onClick={() => fields.remove(index)}>
                  <Icon icon="Trash" />Delete
                </span>
              ) : null}
            </li>
          ))}
        </ul>
        <div>
          {fields.length < maxSize ? (
            <button
              type="button"
              style={{ width: '100%' }}
              className="button button--icon button--theme--secondary"
              onClick={e => {
                e.preventDefault();
                return fields.push({});
              }}
            >
              <Icon icon="Plus" className="icon--small" /> Add Another Time
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}

export default ReduxFormDateTimeArrayInput;



// WEBPACK FOOTER //
// ./src/common/forms/ReduxFormDateTimeArrayInput.js